/**
 * Splashscreen — animated boot screen showing an opening Quran emitting
 * golden light, then revealing the app name. Auto-dismisses after ~2.6s.
 *
 * Shows once per browser tab (sessionStorage flag) so navigating between
 * routes doesn't replay the animation.
 */
import { useEffect, useState } from 'react';
import './Splashscreen.css';

const SHOWN_FLAG = 'noor_splash_shown_v1';

export default function Splashscreen({ onDone }) {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    return sessionStorage.getItem(SHOWN_FLAG) !== '1';
  });
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const t1 = setTimeout(() => setFadingOut(true), 2300);
    const t2 = setTimeout(() => {
      setVisible(false);
      try { sessionStorage.setItem(SHOWN_FLAG, '1'); } catch { /* ignore */ }
      onDone?.();
    }, 2900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!visible) return null;

  return (
    <div
      className={`noor-splash ${fadingOut ? 'noor-splash--out' : ''}`}
      data-testid="app-splashscreen"
      role="dialog"
      aria-label="Noor El Bayen"
    >
      <div className="noor-splash__halo" aria-hidden="true" />
      <div className="noor-splash__rays" aria-hidden="true">
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i} style={{ transform: `rotate(${i * 30}deg)` }} />
        ))}
      </div>

      <div className="noor-splash__book" aria-hidden="true">
        <div className="noor-splash__page noor-splash__page--left" />
        <div className="noor-splash__page noor-splash__page--right" />
        <div className="noor-splash__spine" />
        <div className="noor-splash__beam" />
        <span className="noor-splash__noon">ن</span>
      </div>

      <div className="noor-splash__title">
        <h1 className="noor-splash__arabic">نور البيان</h1>
        <p className="noor-splash__latin">Noor El Bayen</p>
        <p className="noor-splash__tagline">La lumière de l'éloquence</p>
      </div>
    </div>
  );
}
